import { useRoutes as useDOMRoutes } from 'react-router-dom';
import { ExpansionType } from '../types/widget.js';
import { navigationRoutes } from '../utils/navigationRoutes.js';
const routes = [
    {
        path: '/',
        element: ExpansionType.Routes,
    },
    {
        path: navigationRoutes.fromToken,
        element: ExpansionType.FromChain,
    },
    {
        path: navigationRoutes.toToken,
        element: ExpansionType.ToChain,
    },
    {
        path: '*',
        element: null,
    },
];
export const useExpansionRoutes = () => {
    const element = useDOMRoutes(routes);
    return element?.props?.children;
};
//# sourceMappingURL=useExpansionRoutes.js.map